import React, { useState } from "react";
import CustomModal from "../../../../components/modal/CustomModal";
import { Flex } from "antd";
import { IconAlertSquareRounded } from "@tabler/icons-react";
import CustomTextarea from "../../../../components/input/CustomTextarea";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";

const ResolvedModal = ({ visible, onClose, complaintId, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const toast = useToast();

  const reset = () => {
    setComment("");
  };

  const handleCancel = () => {
    if (submitting) return;
    reset();
    onClose?.();
  };

  const handleOk = async () => {
    if (!complaintId || !comment) return;
    try {
      setSubmitting(true);
      const res = await api.resolve_complaint(complaintId, { comment });
      if (res?.status === 200) {
        toast?.("Гомдлыг амжилттай шийдлээ.", "success");
        reset();
        onClose?.();
        onSuccess?.();
      } else {
        const msg =
          res?.data?.errors?.comment || res?.data?.message || "Алдаа гарлаа";
        toast?.(msg, "error");
      }
    } catch (e) {
      toast?.(e?.response?.data?.message || "Серверийн алдаа", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <CustomModal
      open={visible}
      title="Шийдэх"
      onCancel={handleCancel}
      onOk={handleOk}
      disabled={!comment || submitting}
    >
      <Flex vertical gap={10}>
        <Flex
          align="center"
          gap={10}
          style={{ backgroundColor: "#fff6cc", padding: 15, borderRadius: 4 }}
        >
          <IconAlertSquareRounded
            strokeWidth={1.5}
            color="#5f5c73"
            style={{ width: 20, height: 20, flexShrink: 0 }}
          />
          <p style={{ color: "#5f5c73", textAlign: "justify", margin: 0 }}>
            Гомдлыг <b>“Шийдсэн”</b> төлөвт шилжүүлэх гэж байна. Энэ үйлдлийг
            буцаах боломжгүй тул сайтар нягтална уу.
          </p>
        </Flex>

        <CustomTextarea
          required
          title="Тайлбар"
          placeholder="Яаж шийдсэн талаарх богино тайлбар…"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Flex>
    </CustomModal>
  );
};

export default ResolvedModal;
